export default __webpack_public_path__ + "static/media/product-2-2.f6c24bf5.jpg";